module.exports = __webpack_public_path__ + "fad8a5974488905f57323e3288b10c3b.jpg";